export enum PasswordStrength {
    PowerStrong = "power-strong",
    PowerMedium = "power-medium",
    PowerWeak = "power-weak",
    PowerUnacceptable = "power-unacceptable",
}